import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'antd'
import zapIcon from '@assets/images/v2-dashboard/zap.svg'
import './index.css'

interface ButtonBlackProps {
  buttonText?: React.ReactNode;
  loading?: boolean;
  htmlType?: 'submit' | 'button' | 'reset';
  onClick?: () => void;
  holderStyles?: React.CSSProperties;
  buttonStyles?: React.CSSProperties;
  buttonHolderId?: string;
  disabled?: boolean;
  to?: string | false;
  icon?: React.ReactNode;
  title?: string;
  upgrade?: boolean;
}

const ButtonBlack: React.FC<ButtonBlackProps> = ({
  buttonText = 'Submit',
  loading = false,
  htmlType = 'submit',
  onClick = () => {},
  holderStyles = {},
  buttonStyles = {},
  buttonHolderId = '',
  disabled = false,
  to = false,
  icon = '',
  title = '',
  upgrade = false,
}) => {
  return (
    <div id={buttonHolderId} style={holderStyles} className="button-holder-black">
      {to && (
        <Link to={to}>
          {' '}
          <Button
            style={buttonStyles}
            type="primary"
            htmlType={htmlType}
            onClick={onClick}
            loading={loading}
            disabled={disabled}
            title={title}
          >
            {upgrade && <img src={zapIcon} alt="upgrade" />}
            <div className="button-black-text">{buttonText}</div>
          </Button>
        </Link>
      )}
      {!to && (
        <Button
          style={buttonStyles}
          type="primary"
          htmlType={htmlType}
          onClick={onClick}
          loading={loading}
          disabled={disabled}
          icon={icon}
          title={title}
        >
          <span className="button-black-text">{buttonText}</span>
        </Button>
      )}
    </div>
  )
}

export default ButtonBlack
